






























































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import ModalView from '@/components/helper/modal-view.vue';
import VWidget from '@/components/VWidget.vue';
import AgreementMeasure from '@/store/entities/tracing/agreementmeasure';
import Util from '@/lib/util'
import ListBase from '@/lib/listbase';

@Component({
    components: { ModalView, VWidget },
    watch: {
        value: function (val) {
            let obj = (this as any);
            obj.modalShow = val;
            if (val) {
                obj.initForm();
            } else
                this.$emit('input', false);
        },
        modalShow: function (val) {
            if (!val) this.$emit('input', false);
        }
    },
})

export default class AgreementMeasuresList extends ListBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    entity: string = "agreementmeasure";
    measure: AgreementMeasure = new AgreementMeasure();
    nonce: number = 0;


    async save() {
        if (!this.disabled) {

            this.measure.agreement_id = this.agreement.id;

            await this.$store.dispatch({
                type: 'agreementmeasure/create',
                data: this.measure
            });
            this.measure.description = null;

            await this.getpage();
        }
    }

    /************* COMPUTED LIST ***************/
    get userName() {
        return this.$store.state.session.user ? this.$store.state.session.user.full_name : ''
    }

    get loading() {
        return this.$store.state.agreementmeasure.loading;
    }

    get list() {
        return this.$store.state.agreementmeasure.list;
    }

    get totalCount() {
        return this.$store.state.agreementmeasure.totalCount;
    }

    get agreement() {
        return this.$store.state.agreement.editModel;
    }

    get disabled() {
        return this.measure.description == null || this.measure.description == '';
    }

    /********* EVENTOS DE RETORNO DE MODALES ********/


    async initForm() {
        this.measure.description = null;
        await this.getpage();
    }

    async getpage() {
        this.$store.commit('agreementmeasure/new');
        this.measure = Util.extend(true, {}, this.$store.state.agreementmeasure.editModel);
        await this.$store.dispatch({
            type: 'agreementmeasure/getAll',
            data: { id: this.agreement.id }
        });
    }

    async deleteItem(item) {
        await this.$store.dispatch({
            type: 'agreementmeasure/delete',
            data: item
        });
        await this.getpage();
    }
    

    cancel() {
        this.$emit('input', false);
    }

    async mounted() {
        await this.getpage();
    }
}
